<div>
  <div class="pop-bg">
  </div>
  <div class="pop-position pop-w" style="bottom:auto !important">
    <div>
      <div class="row col-md-12 p-0 grey header-popup-box">
        <span class="col-md-10 col-sm-10 p-0">
          <div class="heading-panel pl-10">
            <span class="text-sm text-ellipsis heading-txt flex ml-10">Confirm De-Activate Project </span>
          </div>
        </span>
        <span class="pull-right text-right col-md-2 col-sm-2 pv-10 cursor" (click)="close(false)">
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>
      <div class="col-md-12 p-0">
        <h4 style="text-align: center;">Are you sure you want to De-Activate project ?</h4>
        <div class="col-md-2 submitSection p-0">
          <button type="button" class="btn blue square-btn blue-hover btn-txt mr-10 btn-default" (click)="close(false)">No</button>
          <button type="button" class="btn blue square-btn blue-hover btn-txt btn-default"
            (click)="deActivateProject()">Yes</button>
        </div>
      </div>
    </div>
  </div>
</div>
